import { Card, Grid } from "@material-ui/core";
import AboutUsContainer from "./components/aboutUsContainer";
import Title from '../common/title';
import familyWhole from '../common/images/about-us/family_whole_bw.jpg';

const AboutUs = () => {
  return (
    <Grid container justify="center">
        <Grid item xs={12}>
          <Title img={familyWhole} h1="About Us" />
        </Grid>

        <Grid xs={12} sm={10}>
          <Card style={{ backgroundColor: '#f1f1f1' }}>
            <AboutUsContainer />
          </Card>
        </Grid>

    </Grid>
  );
};

export default AboutUs;
